import { VirtualCardBack, type VirtualCardBackProps } from './VirtualCardBack'
import { VirtualCardFront, type VirtualCardFrontProps } from './VirtualCardFront'

type VirtualCardProps = VirtualCardFrontProps & VirtualCardBackProps

export const VirtualCard = ({ cardId, cardHolder, cardLast4Digits, isFlipped }: VirtualCardProps) => {
  return (
    <div
      className="relative w-64 sm:w-80 h-44 z-10"
      style={{ perspective: '450px' }}
      data-testid="virtual-card-container"
    >
      <div
        className={`
          absolute inset-0 transition-transform duration-700 [transform-style:preserve-3d]
          ${isFlipped ? 'rotate-y-180' : ''}
        `}
      >
        <VirtualCardBack
          cardId={cardId}
          isFlipped={isFlipped}
        />
        <VirtualCardFront
          cardHolder={cardHolder}
          cardLast4Digits={cardLast4Digits}
          isFlipped={isFlipped}
        />
      </div>
    </div>
  )
}
